import { render, staticRenderFns } from "./DsfExamPaperAdd.vue?vue&type=template&id=51fa85bc&"
import script from "./DsfExamPaperAdd.vue?vue&type=script&lang=js&"
export * from "./DsfExamPaperAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfExamPaperAdd.vue"
export default component.exports